import { ValidationErrorData } from '../typings/common';
import { GdUpdateAdGroupRegionsActionInput } from '../typings/graphql-grid';
import { RegionsEditorQuickSelectItem } from '../typings/regionsEditor';

export const OPEN_REGIONS_TRANSFORM_EDITOR = 'OPEN_REGIONS_TRANSFORM_EDITOR';
export type OPEN_REGIONS_TRANSFORM_EDITOR = typeof OPEN_REGIONS_TRANSFORM_EDITOR;

export interface OpenRegionsTransformEditor {
    type: OPEN_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
    campaignsIds: string[];
    groupsIds?: string[];
}

export function openRegionsTransformEditor(
    editorId: string,
    campaignsIds: string[],
    groupsIds?: string[]
): OpenRegionsTransformEditor {
    return {
        type: OPEN_REGIONS_TRANSFORM_EDITOR,
        editorId,
        campaignsIds,
        groupsIds
    };
}

export const CLOSE_REGIONS_TRANSFORM_EDITOR = 'CLOSE_REGIONS_TRANSFORM_EDITOR';
export type CLOSE_REGIONS_TRANSFORM_EDITOR = typeof CLOSE_REGIONS_TRANSFORM_EDITOR;

export interface CloseRegionsTransformEditor {
    type: CLOSE_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
}

export function closeRegionsTransformEditor(editorId: string): CloseRegionsTransformEditor {
    return {
        type: CLOSE_REGIONS_TRANSFORM_EDITOR,
        editorId
    };
}

export const APPLY_REGIONS_TRANSFORM_EDITOR = 'APPLY_REGIONS_TRANSFORM_EDITOR';
export type APPLY_REGIONS_TRANSFORM_EDITOR = typeof APPLY_REGIONS_TRANSFORM_EDITOR;

export interface ApplyRegionsTransformEditor {
    type: APPLY_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
}

export function applyRegionsTransformEditor(editorId: string): ApplyRegionsTransformEditor {
    return {
        type: APPLY_REGIONS_TRANSFORM_EDITOR,
        editorId
    };
}

export const END_APPLY_REGIONS_TRANSFORM_EDITOR = 'END_APPLY_REGIONS_TRANSFORM_EDITOR';
export type END_APPLY_REGIONS_TRANSFORM_EDITOR = typeof END_APPLY_REGIONS_TRANSFORM_EDITOR;

export interface EndApplyRegionsTransformEditor {
    type: END_APPLY_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
}

export function endApplyRegionsTransformEditor(editorId: string): EndApplyRegionsTransformEditor {
    return {
        type: END_APPLY_REGIONS_TRANSFORM_EDITOR,
        editorId
    };
}

export const CLEAR_REGIONS_TRANSFORM_EDITOR = 'CLEAR_REGIONS_TRANSFORM_EDITOR';
export type CLEAR_REGIONS_TRANSFORM_EDITOR = typeof CLEAR_REGIONS_TRANSFORM_EDITOR;

export interface ClearRegionsTransformEditor {
    type: CLEAR_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
}

export function clearRegionsTransformEditor(editorId: string): ClearRegionsTransformEditor {
    return {
        type: CLEAR_REGIONS_TRANSFORM_EDITOR,
        editorId
    };
}

export const CANCEL_REGIONS_TRANSFORM_EDITOR = 'CANCEL_REGIONS_TRANSFORM_EDITOR';
export type CANCEL_REGIONS_TRANSFORM_EDITOR = typeof CANCEL_REGIONS_TRANSFORM_EDITOR;

export interface CancelRegionsTransformEditor {
    type: CANCEL_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
}

export function cancelRegionsTransformEditor(editorId: string): CancelRegionsTransformEditor {
    return {
        type: CANCEL_REGIONS_TRANSFORM_EDITOR,
        editorId
    };
}

export const CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR = 'CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR';
export type CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR = typeof CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR;

export interface ChangeTypeTransformForRegionsTransformEditor {
    type: CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
    typeTransform: GdUpdateAdGroupRegionsActionInput;
}

export function changeTypeTransformForRegionsTransformEditor(
    editorId: string,
    typeTransform: GdUpdateAdGroupRegionsActionInput
): ChangeTypeTransformForRegionsTransformEditor {
    return {
        type: CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR,
        editorId,
        typeTransform
    };
}

export const UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR =
    'UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR';
export type UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR = typeof UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR;

export interface UpdateQuickSelectedItemsForRegionsTransformEditor {
    type: UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
    quickSelectedItems: RegionsEditorQuickSelectItem[];
    isQuickSelectItemsLoading: boolean;
}

export function updateQuickSelectedItemsForRegionsTransformEditor(
    editorId: string,
    quickSelectedItems: RegionsEditorQuickSelectItem[],
    isQuickSelectItemsLoading: boolean
): UpdateQuickSelectedItemsForRegionsTransformEditor {
    return {
        type: UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR,
        editorId,
        quickSelectedItems,
        isQuickSelectItemsLoading
    };
}

export const SHOW_NOTIFICATION_REGIONS_TRANSFORM_EDITOR = 'SHOW_NOTIFICATION_REGIONS_TRANSFORM_EDITOR';
export type SHOW_NOTIFICATION_REGIONS_TRANSFORM_EDITOR = typeof SHOW_NOTIFICATION_REGIONS_TRANSFORM_EDITOR;

export interface ShowNotificationRegionsTransformEditor {
    type: SHOW_NOTIFICATION_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
    campaignIds: string[];
    skippedGroupsIds: string[];
    successGroupsIds: string[];
}

export function showNotificationRegionsTransformEditor(
    editorId: string,
    campaignIds: string[],
    skippedGroupsIds: string[],
    successGroupsIds: string[]
): ShowNotificationRegionsTransformEditor {
    return {
        type: SHOW_NOTIFICATION_REGIONS_TRANSFORM_EDITOR,
        editorId,
        campaignIds,
        skippedGroupsIds,
        successGroupsIds
    };
}

export const FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR = 'FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR';
export type FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR = typeof FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR;

export interface FetchTopRegionsForRegionsTransformEditor {
    type: FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
}

export function fetchTopRegionsForRegionsTransformEditor(editorId: string): FetchTopRegionsForRegionsTransformEditor {
    return {
        type: FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR,
        editorId
    };
}

export const UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR =
    'UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR';
export type UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR = typeof UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR;

export interface UpdateValidationErrorsForRegionsTransformEditor {
    type: UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR;
    editorId: string;
    errors: ValidationErrorData[];
}

export function updateValidationErrorsTransformEditor(
    editorId: string,
    errors: ValidationErrorData[]
): UpdateValidationErrorsForRegionsTransformEditor {
    return {
        type: UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR,
        editorId,
        errors
    };
}

export type RegionsTransformEditorAction =
    | OpenRegionsTransformEditor
    | CloseRegionsTransformEditor
    | ChangeTypeTransformForRegionsTransformEditor
    | CancelRegionsTransformEditor
    | ApplyRegionsTransformEditor
    | ClearRegionsTransformEditor
    | UpdateQuickSelectedItemsForRegionsTransformEditor
    | ShowNotificationRegionsTransformEditor
    | FetchTopRegionsForRegionsTransformEditor
    | UpdateValidationErrorsForRegionsTransformEditor
    | EndApplyRegionsTransformEditor;
